exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".discover-icon .cls-1{\n  fill:#34495e;\n}\n.discover-icon .cls-2{\n  fill:#202121;\n  opacity:.15;\n}\n\n.discover-icon .cls-3{\n  fill:#f26e21;\n}\n.discover-icon .cls-4{\n  fill:#e7e8e3;\n}\n", ""]);
